<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'cloud'
};
</script>

<style>
</style>
